import React, { useState, useEffect, useCallback } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import ModalUser from './ModalUser';

DataTable.use(DT);

function DatatableUser({ announcements, users }) {
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const transformData = useCallback((data, announcementsData) => {
    if (!data || !announcementsData) return [];

    const getUserAdCounts = (annData, userId) => {
      const kilos = Array.isArray(annData.kilos) ? annData.kilos : [];
      const containers = Array.isArray(annData.container) ? annData.container : [];

      return {
          kilos: kilos.filter(ad => ad.userId === userId && ad.active === true).length,
          containers: containers.filter(ad => ad.userId === userId && ad.active === true).length,
      };
    };

    return data.map((item) => {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      const currentAnnonce = getUserAdCounts(announcementsData, item._id);

      return [
        item.name,
        item.email,
        currentAnnonce.containers,
        currentAnnonce.kilos,
        item.locked ? 'Bloqué' : 'Débloqué',
        item?.date?formatDate(item.date):'', // Colonne utilisée pour le tri
        item.locked ? 'Débloqué' : 'Bloqué',
        item._id,
        new Date(item.date).getTime(), // Valeur numérique pour le tri
      ];
    }).sort((a, b) => b[8] - a[8]); // Tri décroissant par date (colonne cachée);
  }, []);

  useEffect(() => {
    if (announcements && users) {
        setTableData(transformData(users, announcements));
    }
  }, [announcements, users, transformData]);

  const columns = [
    { title: 'Nom complet', data: 0 },
    { title: 'Mail', data: 1 },
    { title: 'Conteneur', data: 2 },
    { title: 'Kilo', data: 3 },
    {
      title: 'Statut',
      data: 4,
      render: (statut) => {
        switch (statut) {
          case 'Déconnecté':
            return '<span class="text-warning">Déconnecté</span>';
          case 'Débloqué':
            return '<span class="text-success">Actif</span>';
          case 'Bloqué':
            return '<span class="text-danger">Bloqué</span>';
          default:
            return statut;
        }
      },
    },
    { title: 'Créé le', data: 5 },
    {
      title: 'Action',
      data: 6,
      render: (data) => {
        switch (data) {
          case 'Débloqué':
            return '<button class="btn btn-success btn-sm confirm_lock_user" type="button" data-bs-toggle="modal" data-bs-target="#confirmModal">Débloqué</button>';
          case 'Bloqué':
            return '<button class="btn btn-danger btn-sm confirm_lock_user" type="button" data-bs-toggle="modal" data-bs-target="#confirmModal">Bloqué</button>';
          default:
            return data;
        }
      },
    },
  ];

  // Exemple d’options en français
  const options = {
    order: [[8, 'desc']], // Trie par défaut sur la colonne "Créé le" (index 8)
    language: {
      processing:     'Traitement en cours...',
      search:         'Rechercher&nbsp;:',
      lengthMenu:     'Afficher _MENU_ &eacute;l&eacute;ments',
      info:           'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
      infoEmpty:      'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ments',
      infoFiltered:   '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
      infoPostFix:    '',
      loadingRecords: 'Chargement en cours...',
      zeroRecords:    'Aucun &eacute;l&eacute;ment &agrave; afficher',
      emptyTable:     'Aucune donn&eacute;e disponible dans le tableau',
      paginate: {
        first:      'Premier',
        previous:   'Pr&eacute;c&eacute;dent',
        next:       'Suivant',
        last:       'Dernier',
      },
      aria: {
        sortAscending:  ': activer pour trier la colonne dans l\'ordre croissant',
        sortDescending: ': activer pour trier la colonne dans l\'ordre d&eacute;croissant',
      },
    },
    // Exemple : on utilise `createdRow` pour récupérer l'événement de clic
    // (si vous en avez besoin)
    createdRow: (rowNode, rowData) => {
      const button = rowNode.querySelector('.confirm_lock_user');
      if (button) {
        button.addEventListener('click', () => {
          setSelectedRow(rowData);
        });
      }
    }, /* */
  };

  return (
    <>
      <DataTable
        data={tableData}
        columns={columns}
        options={options}
        className="table table-striped"
        style={{ width: '100%' }}
      />
      {/* Le modal (si vous l'utilisez) */}
      <ModalUser selectedRow={selectedRow} />
    </>
  )
}

export default DatatableUser